module.exports = __webpack_public_path__ + "img/info_billing.9c778eb7.png";